/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface FlightBookingPaymentComponentRequest
 */
export interface FlightBookingPaymentComponentRequest {
  /**
   * Owner-scoped UUID of an ordinary saved payment method. Supplier test mode does not select a separate wallet.
   * @type {string}
   * @memberof FlightBookingPaymentComponentRequest
   */
  savedPaymentMethodId: string;
}

/**
 * Check if a given object implements the FlightBookingPaymentComponentRequest interface.
 */
export function instanceOfFlightBookingPaymentComponentRequest(
  value: object
): value is FlightBookingPaymentComponentRequest {
  if (
    !("savedPaymentMethodId" in value) ||
    value["savedPaymentMethodId"] === undefined
  )
    return false;
  return true;
}

export function FlightBookingPaymentComponentRequestFromJSON(
  json: any
): FlightBookingPaymentComponentRequest {
  return FlightBookingPaymentComponentRequestFromJSONTyped(json, false);
}

export function FlightBookingPaymentComponentRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FlightBookingPaymentComponentRequest {
  if (json == null) {
    return json;
  }
  return {
    savedPaymentMethodId: json["saved_payment_method_id"],
  };
}

export function FlightBookingPaymentComponentRequestToJSON(
  json: any
): FlightBookingPaymentComponentRequest {
  return FlightBookingPaymentComponentRequestToJSONTyped(json, false);
}

export function FlightBookingPaymentComponentRequestToJSONTyped(
  value?: FlightBookingPaymentComponentRequest | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    saved_payment_method_id: value["savedPaymentMethodId"],
  };
}
